import ClientUtils from './utils';

const baseUrl = '/userProfile';

export default {
    getLinks: (partnerBid, callback) => {
        const url = `${baseUrl}/menus`;

        return ClientUtils.makeGetRequest(url, callback);
    },
};
